import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import App from "./App"
import "nprogress/nprogress.css"
import "react-quill/dist/quill.snow.css"
import "simplebar-react/dist/simplebar.min.css"
// import "pure-react-carousel/dist/react-carousel.es.css"
import MultiProvider from "config/MultiProvider"

import id from "date-fns/locale/id"

// Providers
import { GoogleOAuthProvider } from "@react-oauth/google"
import UserProvider from "contexts/UserContext"
import MasterDataProvider from "contexts/MasterDataContext"
import TrademarkProvider from "contexts/TrademarkContext"
import UploadProvider from "contexts/UploadContext"
import MessageProvider from "contexts/MessageContext"
import ActivityLogProvider from "contexts/ActivityLogContext"
import NotificationProvider from "contexts/NotificationContext"
import InvoiceProvider from "contexts/InvoiceContext"
import DashboardProvider from "contexts/DashboardContext"
import TemplateProvider from "contexts/TemplateContext"
import OfficeActionProvider from "contexts/OfficeActionContext"
import LegalProvider from "contexts/LegalContext"
import PaymentItemProvider from "contexts/PaymentItemContext"
import InvReportProvider from "contexts/InvoiceReportContext"
import ReportProvider from "contexts/ReportContext"
import HistoryProvider from "contexts/HistoryContext"
import PatentProvider from "contexts/PatentContext"
import PaginationProvider from "contexts/PaginationContext"

import ContactProvider from "contexts/ContactContext"
import CPatentProvider from "contexts/CPatentContext"
import CDesainIndustriProvider from "contexts/CDesainIndustriContext"

import PatentUploadProvider from "contexts/PatentUploadLogContext"
import LogRecordalProvider from "contexts/LogRecordalContext"
import LogRenewalProvider from "contexts/LogRenewalContext"
import LogPgaProvider from "contexts/LogPgaContext"

import DefaultFeeProvider from "contexts/DefaultFeeContext"
import DashboardPatentProvider from "contexts/DashboardPatentContext"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
				<MultiProvider
					providers={[
						<UserProvider />,
						<ContactProvider />,
						<MasterDataProvider />,
						<TrademarkProvider />,
						<UploadProvider />,
						<MessageProvider />,
						<ActivityLogProvider />,
						<PatentProvider />,
						<NotificationProvider />,
						<InvoiceProvider />,
						<DashboardProvider />,
						<TemplateProvider />,
						<OfficeActionProvider />,
						<LegalProvider />,
						<PaymentItemProvider />,
						<InvReportProvider />,
						<ReportProvider />,
						<HistoryProvider />,
						<PaginationProvider />,
						<PatentUploadProvider />,
						<CPatentProvider />,
						<CDesainIndustriProvider />,
						<LogRecordalProvider />,
						<LogPgaProvider />,
						<LogRenewalProvider />,
						<DefaultFeeProvider />,
						<DashboardPatentProvider />
					]}
				>
					<LocalizationProvider
						dateAdapter={AdapterDateFns}
						adapterLocale={id}
					>
						<App />
					</LocalizationProvider>
				</MultiProvider>
			</GoogleOAuthProvider>
		</BrowserRouter>
	</React.StrictMode>
)
